import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, delay, filter, Observable, switchMap } from 'rxjs';
import {
  FileImportResponse,
  FileParameter,
  FileResponse,
  GstarClient,
} from 'src/app/web-api-client';

@Injectable({
  providedIn: 'root',
})
export class CountryImportService {
  private readonly gstarClient = inject(GstarClient);

  private checkFileImportStatusSubj: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  checkFileImportStatusObs: Observable<number> =
    this.checkFileImportStatusSubj.asObservable();

  fileImport: Observable<FileImportResponse> =
    this.checkFileImportStatusObs.pipe(
      filter(
        (fileImportId: number) => fileImportId !== null && fileImportId !== 0
      ),
      delay(1000), //Wait 1 second before checking status
      switchMap((fileImportId: number) =>
        this.gstarClient.countrytaxnewsfileimports(fileImportId)
      )
    );

  importTaxNewsExcel(
    request: FileParameter,
    countryId: number
  ): Observable<FileImportResponse> {
    return this.gstarClient.upload(countryId, request);
  }

  downloadTaxNewsTemplate(): Observable<FileResponse> {
    return this.gstarClient.download();
  }

  reloadFileImportStatus(fileImportId: number): void {
    this.checkFileImportStatusSubj.next(fileImportId);
  }
}
